// Gestores (7-oct-2026): la pestaña «Gestión» de Analítica y los filtros de gestionados /
// propios / propietario de las pestañas Desempeño y Canales.
export const gestionAnalytics = {
  tab: "Verwaltung",
  tabRestricted: "Meine Abrechnung",
  restrictedTitle: "Meine Abrechnung",

  pageFilters: {
    ownership: "Unterkünfte",
    ownershipAll: "Verwaltete und eigene",
    ownershipManaged: "Nur verwaltete",
    ownershipOwn: "Nur eigene",
    owner: "Eigentümer",
    allOwners: "Alle Eigentümer",
  },

  views: {
    business: "Mein Geschäft",
    owners: "Eigentümer",
    expenses: "Ausgaben",
  },

  filters: {
    listings: "Unterkünfte",
    allListings: "Alle",
    someListings: "{count} Unterkünfte",
    owner: "Eigentümer",
    allOwners: "Alle",
    attribution: "Buchungen zählen nach",
    checkout: "Abreisedatum",
    checkin: "Anreisedatum",
    nights: "Nächte im Zeitraum",
    attributionHelp: "Nach Abreise wird mit den Eigentümern abgerechnet: Der Aufenthalt ist bereits beendet.",
    attributionHelpLabel: "Was „Buchungen zählen nach“ bedeutet",
    currency: "Währung",
  },

  warnings: {
    otaEstimated:
      "{count} Buchung mit prozentual geschätzter OTA-Provision: Der Kanal hat die tatsächliche nicht übermittelt. | {count} Buchungen mit prozentual geschätzter OTA-Provision: Der Kanal hat die tatsächliche nicht übermittelt.",
    noBreakdown:
      "{count} Buchung ohne Aufschlüsselung: Der gesamte Betrag wurde als Unterkunft gewertet. | {count} Buchungen ohne Aufschlüsselung: Der gesamte Betrag wurde jeweils als Unterkunft gewertet.",
    outdatedBreakdown:
      "{count} Buchung wurde nach dem Import geändert oder verlängert: Ihr aktueller Betrag wurde verwendet. | {count} Buchungen wurden nach dem Import geändert oder verlängert: Ihr aktueller Betrag wurde verwendet.",
    otherCurrencies: "Es gibt Unterkünfte in einer anderen Währung ({currencies}). Wechseln Sie sie oben, um sie zu sehen.",
    noOwner:
      "{count} verwaltete Unterkunft hat keinen zugewiesenen Eigentümer. | {count} verwaltete Unterkünfte haben keinen zugewiesenen Eigentümer.",
    assignOwners: "Eigentümer zuweisen",
  },

  states: {
    loadError: "Die Verwaltungsdaten konnten nicht geladen werden.",
    forbidden: "Sie haben keine Berechtigung, diese Informationen zu sehen.",
    periodTooLong: "Wählen Sie einen Zeitraum von höchstens zwei Jahren.",
    retry: "Erneut versuchen",
    noMovements: "Keine Bewegungen in diesem Zeitraum",
  },

  empty: {
    title: "Verwalten Sie Unterkünfte für andere Eigentümer?",
    text: "Legen Sie bei jeder Unterkunft fest, dass Sie sie für einen Eigentümer verwalten, und zu welchen Bedingungen: Ihre Provision, wer die Buchungen kassiert und wie die Reinigung geregelt ist. Hier sehen Sie, was Sie verdienen und was jedem Eigentümer zusteht.",
    point1: "Ihre Provisionen, Reinigungen und Ausgaben – mit Ihrem echten Gewinn",
    point2: "Was Sie jedem Eigentümer überweisen oder in Rechnung stellen",
    point3: "Die Abrechnung jedes Eigentümers als PDF oder Excel",
    cta: "Meine Unterkünfte einrichten",
  },

  period: {
    subtitle: "{period} · {attribution} · {granularity}",
    byCheckout: "Buchungen nach Abreisedatum",
    byCheckin: "Buchungen nach Anreisedatum",
    byNights: "Nächte im Zeitraum",
    day: "pro Tag",
    week: "pro Woche",
    month: "pro Monat",
  },

  counts: {
    reservations: "{count} Buchung | {count} Buchungen",
    nights: "{count} Nacht | {count} Nächte",
    units: "{count} Unterkunft | {count} Unterkünfte",
    ownUnits: "{count} eigene Unterkunft | {count} eigene Unterkünfte",
    owners: "{count} Eigentümer | {count} Eigentümer",
  },

  business: {
    kpi: {
      managedGross: "Verwalteter Umsatz",
      commissions: "Ihre Provisionen",
      cleaning: "Reinigung",
      ownRevenue: "Umsatz eigener Unterkünfte",
      expenses: "Ausgaben",
      profit: "Gewinn",
    },
    vatLine: "+ MwSt. {amount}",
    ofTotal: "des Gesamtumsatzes",
    overManaged: "des verwalteten Umsatzes",
    ofIncome: "Ihrer Einnahmen",
    margin: "Marge",
    chartTitle: "Einnahmen, Ausgaben und Gewinn",
    chartA11y: "Diagramm der Einnahmen, Ausgaben und des Gewinns im Zeitraum",
    legend: {
      commissions: "Provisionen",
      cleaning: "Reinigung",
      own: "Eigene Unterkünfte",
      expenses: "Ausgaben",
      profit: "Gewinn",
    },
    byCategory: "Ausgaben nach Kategorie",
    category: "Kategorie",
    amount: "Betrag",
    noExpenses: "Keine Ausgaben in diesem Zeitraum",
    seeExpenses: "Ausgaben ansehen",
  },

  owners: {
    kpi: {
      gross: "Buchungsumsatz",
      ota: "OTA-Provisionen",
      cleaning: "Reinigung",
      commission: "Ihre Provision + MwSt.",
      commissionRestricted: "Provision des Verwalters + MwSt.",
      charged: "Weiterberechnete Kosten",
      net: "Netto für Eigentümer",
      netRestricted: "Ihr Netto",
    },
    ofGross: "des Umsatzes",
    collectedByYou: "kassieren Sie",
    collectedByManager: "kassiert Ihr Verwalter",
    commissionLine: "{commission} + MwSt. {vat}",
    otaLine: "{commission} + MwSt. {vat}",
    otaTitle: "OTA-Provision {commission} + MwSt. {vat}",
    commissionTitle: "Provision {commission} + MwSt. {vat}",
    toTransfer: "An Eigentümer auszuzahlen",
    toCollect: "Von Eigentümern einzufordern",
    toTransferRestricted: "Ihr Verwalter überweist Ihnen",
    toCollectRestricted: "An Ihren Verwalter zu zahlen",
    chartTitle: "Aufteilung der Einnahmen",
    chartA11y: "Diagramm der Aufteilung des Umsatzes aus verwalteten Buchungen",
    legend: {
      net: "Netto Eigentümer",
      netRestricted: "Ihr Netto",
      commissions: "Ihre Provisionen",
      commissionsRestricted: "Provision des Verwalters",
      ota: "OTA-Provisionen",
      cleaning: "Reinigung",
      other: "Steuern, Kautionen, MwSt. und Kosten",
    },
    grossFooter: "Umsatz: {amount}",
    tableTitle: "Abrechnung pro Eigentümer",
    tableTitleRestricted: "Details Ihrer Abrechnung",
    downloadAll: "Alles herunterladen (PDF)",
    download: "Herunterladen (PDF)",
    downloading: "Wird heruntergeladen…",
    pdf: "PDF",
    excel: "Excel",
    exportError: "Die Abrechnung konnte nicht heruntergeladen werden.",
    cols: {
      owner: "Eigentümer",
      reservations: "Buchungen",
      gross: "Umsatz",
      ota: "OTA",
      cleaning: "Reinigung",
      commission: "Provision + MwSt.",
      charged: "Kosten",
      net: "Netto",
      balance: "Saldo",
      actions: "Downloads",
    },
    noOwner: "Kein Eigentümer zugewiesen",
    transfer: "Auszahlung {amount}",
    collect: "Forderung {amount}",
    receive: "Sie erhalten {amount}",
    pay: "Sie zahlen {amount}",
    collectionManager: "Verwalter kassiert",
    collectionOwner: "Eigentümer kassiert",
    total: "Gesamt",
    expand: "Details von {name} anzeigen",
    collapse: "Details von {name} ausblenden",
    iban: "IBAN {iban}",
    showReservations: "Buchungen ansehen ({count})",
    hideReservations: "Buchungen ausblenden",
    noData: "Keine verwalteten Buchungen in diesem Zeitraum.",
    reservations: {
      checkIn: "Anreise",
      checkOut: "Abreise",
      guest: "Gast",
      listing: "Unterkunft",
      channel: "Kanal",
      gross: "Umsatz",
      ota: "OTA",
      cleaning: "Reinigung",
      commission: "Provision",
      vat: "MwSt.",
      net: "Netto",
      direct: "Direkt",
      estimated: "geschätzt",
      estimatedHelp: "Prozentual geschätzt: Der Kanal hat die tatsächliche Provision nicht übermittelt.",
      noBreakdown: "ohne Aufschlüsselung",
      noBreakdownHelp: "Die Buchung hat keine Aufschlüsselung: Der gesamte Betrag wurde als Unterkunft gewertet.",
      complete: "Complete",
      completed: "Completed",
      completeHelp: "Fill in cleaning, the real OTA commission or the cleaning for this booking",
      manual: "manual",
      manualHelp: "OTA commission entered by hand for this booking.",
      loading: "Buchungen werden geladen…",
      loadError: "Die Buchungen konnten nicht geladen werden.",
      empty: "Keine Buchungen in diesem Zeitraum.",
    },
    charged: {
      title: "An den Eigentümer weiterberechnete Kosten",
      date: "Datum",
      concept: "Beschreibung",
      listing: "Unterkunft",
      amount: "Betrag",
      general: "Allgemein",
    },
  },

  a11y: {
    views: "Verwaltungsbereiche",
  },
  // Liquidación por propietario: la cuenta y las columnas del PDF.
  liq: {
    precio: "Preis",
    comision: "OTA-Provision",
    tasas: "Steuern",
    limpieza: "Reinigung",
    honorarios: "Honorar",
    honorariosIva: "Honorar + MwSt.",
    neto: "Netto Eigentümer",
    transfieres: "Sie überweisen",
    tePaga: "Er zahlt Ihnen",
    recibes: "Sie erhalten",
    pagas: "Sie zahlen",
    netoPropietarios: "Netto für Eigentümer",
    formula: "Einnahme = Preis − Provision · Gesamt = Einnahme − Steuern − Reinigung · Netto = Gesamt − Honorar − MwSt. Wie im PDF und Excel.",
    cols: {
      origen: "Herkunft",
      nombre: "Name",
      entrada: "Anreise",
      salida: "Abreise",
      precio: "Preis",
      noches: "Nächte",
      comision: "Provision",
      ingreso: "Einnahme",
      tasas: "Steuern",
      limpieza: "Reinigung",
      total: "Gesamt",
      honorarios: "Honorar",
      iva: "MwSt.",
      neto: "Netto",
    },
  },
};
